import {
  BooleanParam,
  DateTimeParam,
  NumberParam,
  StringParam,
  withDefault,
} from 'use-query-params';

import { PaymentSearchOrder } from '@/globalTypes';
import {
  BrandParam,
  PaymentSearchOrderParam,
  PaymentStatusParam,
  PaymentTypeParam,
} from '@/utils/query/params';

export const queryParams = {
  rawId: StringParam,
  brand: BrandParam,
  paymentType: PaymentTypeParam,
  paymentStatus: PaymentStatusParam,
  from: DateTimeParam,
  to: DateTimeParam,
  desc: withDefault(BooleanParam, true),
  orderBy: withDefault(
    PaymentSearchOrderParam,
    PaymentSearchOrder.initializedAt,
  ),
  before: StringParam,
  after: StringParam,
  first: withDefault(NumberParam, 20),
};
